<div class="tw-w-full">
    <div class="tw-flex tw-justify-end tw-items-center tw-p-5 !tw-z-49">
        <div class="d-flex gap-2 align-items-center">
            @if (!isExternalUser) {
                <button
                    mat-flat-button
                    color="warn"
                    (click)="returnToOverview(true)">
                    <mat-icon fontSet="material-symbols-outlined"
                        >arrow_back
                    </mat-icon>
                    {{ 'ECMR.common.back' | translate }}
                </button>
                @if (editorMode === EditorMode.ECMR_NEW) {
                    <button
                        mat-stroked-button
                        color="warn"
                        (click)="resetForm()"
                        [disabled]="isReadOnly">
                        <mat-icon fontSet="material-symbols-outlined"
                            >restart_alt
                        </mat-icon>
                        {{ 'ECMR.common.reset' | translate }}
                    </button>
                }
                @if (!isTemplate()) {
                    <button
                        mat-stroked-button
                        color="primary"
                        (click)="loadFromTemplate()"
                        [disabled]="checkEcmrStatusNew() || isReadOnly">
                        <mat-icon
                            iconPositionEnd
                            fontSet="material-symbols-outlined"
                            >upload_file
                        </mat-icon>
                        {{ 'ECMR.ecmr_editor.load_from_template' | translate }}
                    </button>
                }
                @if (!isTemplate()) {
                    <button
                        mat-flat-button
                        color="primary"
                        [disabled]="isReadOnly"
                        (click)="saveTemplate(false)">
                        <mat-icon
                            iconPositionEnd
                            fontSet="material-symbols-outlined"
                            >description
                        </mat-icon>
                        {{ 'ECMR.ecmr_editor.save_as_template' | translate }}
                    </button>
                }
            } @else {
                <button
                    mat-stroked-button
                    color="primary"
                    (click)="
                        ecmrActionService.downloadPdf(
                            ecmrToEdit.ecmrId!,
                            userToken,
                            tan,
                            ecmrToEdit.ecmrConsignment
                                .referenceIdentificationNumber.value!,
                            dcaCompliant
                        )
                    ">
                    {{ 'ECMR.quick_view_buttons.pdf' | translate }}
                    <mat-icon
                        iconPositionEnd
                        fontSet="material-symbols-outlined"
                        >picture_as_pdf
                    </mat-icon>
                </button>
            }
            <button
                mat-flat-button
                color="primary"
                (click)="
                    isTemplate()
                        ? saveTemplate(true)
                        : saveEcmr(!isExternalUser)
                "
                [disabled]="disableSave()">
                <mat-icon
                    iconPositionEnd
                    fontSet="material-symbols-outlined"
                    >save
                </mat-icon>
                {{ 'ECMR.common.save' | translate }}
            </button>
        </div>
    </div>
    <div
        class="container-fluid"
        [formGroup]="ecmrConsignmentFormGroup">
        <div
            class="row"
            [class.custom-template-style]="isTemplate()">
            <div
                class="m-3 d-flex flex-column gap-3 overflow-container col pb-3">
                <mat-card class="header-card">
                    <mat-card-content
                        class="d-flex flex-row justify-content-between align-items-center">
                        <div
                            class="flex-grow-1 d-flex gap-3 flex-row align-items-center overflow-hidden"
                            formGroupName="referenceIdentificationNumber">
                            <div class="ecmr-cmr-logo">
                                <div>CMR</div>
                            </div>

                            <!-- Area 26 -->

                            <mat-form-field
                                class="flex-grow-1 id-input"
                                subscriptSizing="dynamic">
                                <mat-label
                                    >{{
                                        'ECMR.ecmr_editor.reference_id'
                                            | translate
                                    }}
                                </mat-label>
                                <input
                                    matInput
                                    type="text"
                                    [dynamicDisable]="!canFillSenderFields"
                                    formControlName="value" />
                                @if (
                                    ecmrConsignmentFormGroup.controls.referenceIdentificationNumber.controls.value.hasError(
                                        'required'
                                    )
                                ) {
                                    <mat-error
                                        >{{ 'ECMR.error.required' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div
                            class="d-flex flex-grow-1 flex-row justify-content-end">
                            @if (!isTemplate() && checkSignStatus()) {
                                <button
                                    mat-flat-button
                                    color="primary"
                                    (click)="scrollToElement()">
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        iconPositionEnd
                                        >draw
                                    </mat-icon>
                                    {{ 'ECMR.ecmr_editor.sign' | translate }}
                                </button>
                            }
                        </div>
                    </mat-card-content>
                    @if (dcaCompliant) {
                        <div class="px-3 pb-2 mt-2">
                            {{ 'ECMR.ecmr_editor.dca_compliance' | translate }}
                        </div>
                    }
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row">
                            <!-- Area 1 -->

                            <div
                                class="d-flex gap-1 flex-column col"
                                formGroupName="senderInformation">
                                <h6
                                    id="sender-title"
                                    [class.alignedWithConsigneeFields]="
                                        alignSenderAndConsigneeFields
                                    ">
                                    {{ 'ECMR.ecmr_editor.title_1' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.sender.name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="senderCompanyName" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.senderInformation
                                            .get('senderCompanyName')
                                            ?.hasError('mandatoryForSigning')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.sender.person_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="senderPersonName"
                                        [minlength]="2"
                                        [maxlength]="60" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.senderInformation
                                            .get('senderPersonName')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.sender.street_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="senderStreet"
                                        [minlength]="2"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.senderInformation
                                            .get('senderStreet')
                                            ?.hasError('mandatoryForSigning')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                    @if (
                                        ecmrConsignmentFormGroup.controls.senderInformation
                                            .get('senderStreet')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="d-flex flex-row gap-1 flex-wrap">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.sender.post_code'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="senderPostcode"
                                            [minlength]="2"
                                            [maxlength]="17" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation
                                                .get('senderPostcode')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation
                                                .get('senderPostcode')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.sender.city_name'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="senderCity"
                                            [minlength]="2"
                                            [maxlength]="60" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation
                                                .get('senderCity')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation
                                                .get('senderCity')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <ng-container formGroupName="senderCountryCode">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.sender.country'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            formControlName="value"
                                            maxlength="2"
                                            (input)="
                                                transformToUppercase('sender')
                                            "
                                            (blur)="checkCountry('sender')"
                                            [matAutocomplete]="
                                                senderCountryAutocomplete
                                            " />
                                        <mat-autocomplete
                                            #senderCountryAutocomplete="matAutocomplete">
                                            @for (
                                                country of filteredSenderCountries
                                                    | async;
                                                track country
                                            ) {
                                                <mat-option [value]="country"
                                                    >{{ country }}
                                                </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderCountryCode
                                                .get('value')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderCountryCode
                                                .get('value')
                                                ?.hasError('invalidCountryCode')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_countryCode'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </ng-container>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.sender.tax_number'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="taxNumber"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.senderInformation.controls.taxNumber?.hasError(
                                            'mandatoryForSigning'
                                        )
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div
                                    formGroupName="senderContactInformation"
                                    class="d-flex flex-column">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.sender.email'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="email"
                                            [maxlength]="255" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderContactInformation
                                                .get('email')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderContactInformation
                                                .get('email')
                                                ?.hasError('invalidEmail')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_email'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.sender.phone'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="phone"
                                            [maxlength]="15" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderContactInformation
                                                .get('phone')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.senderInformation.controls.senderContactInformation
                                                .get('phone')
                                                ?.hasError('invalidPhoneNumber')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_phone'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Area 2 -->

                            <div class="d-flex gap-1 flex-column col">
                                <!--                            TODO Add this section when legal issues are resolved -->
                                <!--                            <div formGroupName="multiConsigneeShipment">-->
                                <!--                                <mat-checkbox-->
                                <!--                                    [dynamicDisable]="!canFillSenderFields"-->
                                <!--                                    (change)="isMultiConsigneeShipmentCheckboxChange($event)"-->
                                <!--                                    formControlName="isMultiConsigneeShipment">-->
                                <!--                                        {{ "ecmr_editor.multi_consignee_shipment.is_multi_consignee_shipment" | translate }}-->
                                <!--                                </mat-checkbox>-->
                                <!--                            </div>-->
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_2' | translate }}
                                </h6>
                                @if (
                                    !ecmrConsignmentFormGroup.controls.multiConsigneeShipment.get(
                                        'isMultiConsigneeShipment'
                                    )?.value
                                ) {
                                    <div
                                        class="d-flex flex-column gap-1 flex-wrap"
                                        formGroupName="consigneeInformation">
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.consignee.name'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="consigneeCompanyName" />
                                            @if (
                                                ecmrConsignmentFormGroup.controls.consigneeInformation.get(
                                                    'consigneeCompanyName'
                                                )?.invalid
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.consignee.person_name'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="consigneePersonName"
                                                [minlength]="2"
                                                [maxlength]="60" />
                                            @if (
                                                ecmrConsignmentFormGroup.controls.consigneeInformation
                                                    .get('consigneePersonName')
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.consignee.street_name'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="consigneeStreet"
                                                [minlength]="2"
                                                [maxlength]="255" />
                                            @if (
                                                ecmrConsignmentFormGroup.controls.consigneeInformation
                                                    .get('consigneeStreet')
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                ecmrConsignmentFormGroup.controls.consigneeInformation
                                                    .get('consigneeStreet')
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <div
                                            class="d-flex flex-row gap-1 flex-wrap">
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.consignee.post_code'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="consigneePostcode"
                                                    [minlength]="2"
                                                    [maxlength]="17" />
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation
                                                        .get(
                                                            'consigneePostcode'
                                                        )
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation
                                                        .get(
                                                            'consigneePostcode'
                                                        )
                                                        ?.hasError('minlength')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_too_short'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.consignee.city_name'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="consigneeCity"
                                                    [minlength]="2"
                                                    [maxlength]="60" />
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation
                                                        .get('consigneeCity')
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation
                                                        .get('consigneeCity')
                                                        ?.hasError('minlength')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_too_short'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <ng-container
                                            formGroupName="consigneeCountryCode">
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.consignee.country'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="value"
                                                    maxlength="2"
                                                    (input)="
                                                        transformToUppercase(
                                                            'consignee'
                                                        )
                                                    "
                                                    (blur)="
                                                        checkCountry(
                                                            'consignee'
                                                        )
                                                    "
                                                    [matAutocomplete]="
                                                        consigneeCountryAutocomplete
                                                    " />
                                                <mat-autocomplete
                                                    #consigneeCountryAutocomplete="matAutocomplete">
                                                    @for (
                                                        country of filteredConsigneeCountries
                                                            | async;
                                                        track country
                                                    ) {
                                                        <mat-option
                                                            [value]="country"
                                                            >{{ country }}
                                                        </mat-option>
                                                    }
                                                </mat-autocomplete>
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeCountryCode
                                                        .get('value')
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeCountryCode
                                                        .get('value')
                                                        ?.hasError(
                                                            'invalidCountryCode'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.common.errors.invalid_countryCode'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </ng-container>
                                        <div
                                            formGroupName="consigneeContactInformation"
                                            class="d-flex flex-column">
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.consignee.email'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="email"
                                                    [maxlength]="255" />
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeContactInformation
                                                        .get('email')
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeContactInformation
                                                        .get('email')
                                                        ?.hasError(
                                                            'invalidEmail'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.common.errors.invalid_email'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.consignee.phone'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="phone"
                                                    [maxlength]="15" />
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeContactInformation
                                                        .get('phone')
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    ecmrConsignmentFormGroup.controls.consigneeInformation.controls.consigneeContactInformation
                                                        .get('phone')
                                                        ?.hasError(
                                                            'invalidPhoneNumber'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.common.errors.invalid_phone'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                    </div>
                                }
                                @if (
                                    ecmrConsignmentFormGroup.controls.multiConsigneeShipment.get(
                                        'isMultiConsigneeShipment'
                                    )?.value
                                ) {
                                    <div>
                                        {{
                                            'ECMR.ecmr_editor.multi_consignee_shipment.multi_consignee_shipment_notice'
                                                | translate
                                        }}
                                    </div>
                                }
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row">
                            <div class="col">
                                <!-- Area 3 -->

                                <div
                                    formGroupName="takingOverTheGoods"
                                    class="d-flex flex-column gap-1 flex-grow-1 mb-3">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_3'
                                                | translate
                                        }}
                                    </h6>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.taking_over_the_goods.place'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="takingOverTheGoodsPlace"
                                            class="flex-grow-1"
                                            [minlength]="2"
                                            [maxlength]="60" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.takingOverTheGoods
                                                .get('takingOverTheGoodsPlace')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.takingOverTheGoods
                                                .get('takingOverTheGoodsPlace')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <div
                                        class="d-flex flex-row gap-2 flex-grow-1 flex-wrap">
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.taking_over_the_goods.time_of_arrival'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                formControlName="logisticsTimeOfArrivalDateTime"
                                                [matDatepicker]="
                                                    timeOfArrivalPicker
                                                " />
                                            <mat-datepicker
                                                #timeOfArrivalPicker></mat-datepicker>
                                            <mat-datepicker-toggle
                                                matIconSuffix
                                                [for]="
                                                    timeOfArrivalPicker
                                                "></mat-datepicker-toggle>
                                            @if (
                                                ecmrConsignmentFormGroup.controls.takingOverTheGoods.get(
                                                    'logisticsTimeOfArrivalDateTime'
                                                )?.invalid
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.taking_over_the_goods.time_of_departure'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                formControlName="logisticsTimeOfDepartureDateTime"
                                                [matDatepicker]="
                                                    timeOfDeparturePicker
                                                " />
                                            <mat-datepicker
                                                #timeOfDeparturePicker></mat-datepicker>
                                            <mat-datepicker-toggle
                                                matIconSuffix
                                                [for]="
                                                    timeOfDeparturePicker
                                                "></mat-datepicker-toggle>
                                            @if (
                                                ecmrConsignmentFormGroup.controls.takingOverTheGoods.get(
                                                    'logisticsTimeOfDepartureDateTime'
                                                )?.invalid
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Area 4 -->

                                <div
                                    formGroupName="deliveryOfTheGoods"
                                    class="flex-grow-1 d-flex gap-1 flex-column">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_4'
                                                | translate
                                        }}
                                    </h6>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.delivery_of_the_goods.place'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            formControlName="logisticsLocationCity"
                                            [minlength]="2"
                                            [maxlength]="60" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.deliveryOfTheGoods
                                                .get('logisticsLocationCity')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.delivery_of_the_goods.opening_hours'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <textarea
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            formControlName="logisticsLocationOpeningHours"
                                            [minlength]="2"
                                            [maxlength]="255"></textarea>
                                        @if (
                                            ecmrConsignmentFormGroup.controls.deliveryOfTheGoods
                                                .get(
                                                    'logisticsLocationOpeningHours'
                                                )
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Area 5 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column justify-content-start col"
                                formGroupName="sendersInstructions">
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_5' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1 h-100">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.senders_instruction.description'
                                                | translate
                                        }}
                                    </mat-label>
                                    <textarea
                                        [dynamicDisable]="!canFillSenderFields"
                                        class="flex-grow-1 multi-line-text"
                                        cdkTextareaAutosize
                                        matInput
                                        formControlName="transportInstructionsDescription"
                                        [minlength]="2"
                                        [maxlength]="512"></textarea>
                                    @if (
                                        ecmrConsignmentFormGroup.controls.sendersInstructions
                                            .get(
                                                'transportInstructionsDescription'
                                            )
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row align-items-start">
                            <!-- Area 6 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="carrierInformation">
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_6' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.carrier_information.name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="carrierCompanyName" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation.get(
                                            'carrierCompanyName'
                                        )?.invalid
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.carrier_information.person_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="carrierDriverName"
                                        [minlength]="2"
                                        [maxlength]="60" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation
                                            .get('carrierDriverName')
                                            ?.hasError('mandatoryForSigning')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation
                                            .get('carrierDriverName')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.carrier_information.street_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="carrierStreet"
                                        [minlength]="2"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation
                                            .get('carrierStreet')
                                            ?.hasError('mandatoryForSigning')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation
                                            .get('carrierStreet')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="d-flex flex-row gap-1 flex-wrap">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.post_code'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="carrierPostcode"
                                            [minlength]="2"
                                            [maxlength]="17" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation
                                                .get('carrierPostcode')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation
                                                .get('carrierPostcode')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.city_name'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="carrierCity"
                                            [minlength]="2"
                                            [maxlength]="60" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation
                                                .get('carrierCity')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation
                                                .get('carrierCity')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <ng-container
                                    formGroupName="carrierCountryCode">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.country'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="value"
                                            maxlength="2"
                                            (input)="
                                                transformToUppercase('carrier')
                                            "
                                            (blur)="checkCountry('carrier')"
                                            [matAutocomplete]="
                                                carrierCountryAutocomplete
                                            " />
                                        <mat-autocomplete
                                            #carrierCountryAutocomplete="matAutocomplete">
                                            @for (
                                                country of filteredCarrierCountries
                                                    | async;
                                                track country
                                            ) {
                                                <mat-option [value]="country"
                                                    >{{ country }}
                                                </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierCountryCode
                                                .get('value')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierCountryCode
                                                .get('value')
                                                ?.hasError('invalidCountryCode')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_countryCode'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </ng-container>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.carrier_information.tax_number'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="taxNumber"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carrierInformation.controls.taxNumber?.hasError(
                                            'mandatoryForSigning'
                                        )
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <!-- Vehicle configuration history (replaces the single license plate) -->
                                <div
                                    formArrayName="vehicleConfigurationHistory"
                                    class="d-flex flex-column gap-2">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.vehicle_configuration.title'
                                                | translate
                                        }}
                                    </h6>
                                    @if (
                                        (ecmrConsignmentFormGroup.controls
                                            .carrierInformation.controls
                                            .vehicleConfigurationHistory.value
                                            | latestMotorPlate) !== ''
                                    ) {
                                        <p class="mb-1">
                                            {{
                                                'ECMR.ecmr_editor.vehicle_configuration.current_plate'
                                                    | translate
                                            }}:
                                            <strong>{{
                                                ecmrConsignmentFormGroup
                                                    .controls.carrierInformation
                                                    .controls
                                                    .vehicleConfigurationHistory
                                                    .value | latestMotorPlate
                                            }}</strong>
                                        </p>
                                    }
                                    @for (
                                        configCtrl of ecmrConsignmentFormGroup
                                            .controls.carrierInformation
                                            .controls
                                            .vehicleConfigurationHistory
                                            .controls;
                                        let vIdx = $index;
                                        track configCtrl
                                    ) {
                                        <div
                                            class="d-flex flex-column gap-1 border rounded p-2"
                                            [formGroupName]="vIdx">
                                            <div
                                                class="d-flex align-items-center justify-content-between">
                                                <span class="fw-bold"
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.title'
                                                            | translate
                                                    }}
                                                    {{ vIdx + 1 }}</span
                                                >
                                                @if (
                                                    (canFillSenderFields ||
                                                        canFillCarrierFields ||
                                                        canCarrierEditInTransport) &&
                                                    ecmrConsignmentFormGroup
                                                        .controls
                                                        .carrierInformation
                                                        .controls
                                                        .vehicleConfigurationHistory
                                                        .length > 1
                                                ) {
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        color="warn"
                                                        (click)="
                                                            removeVehicleConfig(
                                                                'carrier',
                                                                vIdx
                                                            )
                                                        "
                                                        [matTooltip]="
                                                            'ECMR.ecmr_editor.vehicle_configuration.remove'
                                                                | translate
                                                        ">
                                                        <mat-icon
                                                            fontSet="material-symbols-outlined"
                                                            >delete</mat-icon
                                                        >
                                                    </button>
                                                }
                                            </div>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.date'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    formControlName="timestamp"
                                                    [max]="today"
                                                    [matDatepicker]="
                                                        vehicleConfigPicker
                                                    " />
                                                <mat-datepicker
                                                    #vehicleConfigPicker></mat-datepicker>
                                                <mat-datepicker-toggle
                                                    matIconSuffix
                                                    [for]="
                                                        vehicleConfigPicker
                                                    "></mat-datepicker-toggle>
                                                @if (
                                                    configCtrl
                                                        .get('timestamp')
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                } @else if (
                                                    configCtrl
                                                        .get('timestamp')
                                                        ?.hasError('required')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.date_required'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    configCtrl
                                                        .get('timestamp')
                                                        ?.hasError('futureDate')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.date_future'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.motor_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="motorVehicleLicensePlate"
                                                    [maxlength]="255" />
                                                @if (
                                                    configCtrl
                                                        .get(
                                                            'motorVehicleLicensePlate'
                                                        )
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                } @else if (
                                                    configCtrl
                                                        .get(
                                                            'motorVehicleLicensePlate'
                                                        )
                                                        ?.hasError('required')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.motor_plate_required'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.trailer_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="trailerLicensePlate"
                                                    [maxlength]="255" />
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.second_trailer_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="secondTrailerLicensePlate"
                                                    [maxlength]="255" />
                                            </mat-form-field>
                                        </div>
                                    }
                                    @if (
                                        canFillSenderFields ||
                                        canFillCarrierFields ||
                                        canCarrierEditInTransport
                                    ) {
                                        <button
                                            mat-stroked-button
                                            type="button"
                                            (click)="
                                                addVehicleConfig('carrier')
                                            ">
                                            <mat-icon
                                                fontSet="material-symbols-outlined"
                                                >add</mat-icon
                                            >
                                            {{
                                                'ECMR.ecmr_editor.vehicle_configuration.add'
                                                    | translate
                                            }}
                                        </button>
                                    }
                                </div>
                                <div
                                    formGroupName="carrierContactInformation"
                                    class="d-flex flex-column">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.email'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="email"
                                            [maxlength]="255" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierContactInformation
                                                .get('email')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierContactInformation
                                                .get('email')
                                                ?.hasError('invalidEmail')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_email'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.phone'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="carrierPhone"
                                            [maxlength]="32" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierContactInformation
                                                .get('carrierPhone')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierContactInformation
                                                .get('carrierPhone')
                                                ?.hasError('invalidPhoneNumber')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_phone'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.carrier_information.driver_phone'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="driverPhone"
                                            [maxlength]="32" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.carrierInformation.controls.carrierContactInformation
                                                .get('driverPhone')
                                                ?.hasError('invalidPhoneNumber')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_phone'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Area 7 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="successiveCarrierInformation">
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_7' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.successive_carrier_information.name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="successiveCarrierCompanyName" />
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.successive_carrier_information.person_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="successiveCarrierDriverName"
                                        [minlength]="2"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.successiveCarrierInformation
                                            .get('successiveCarrierDriverName')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.successive_carrier_information.street_name'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="successiveCarrierStreet"
                                        [minlength]="2"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.successiveCarrierInformation
                                            .get('successiveCarrierStreet')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="d-flex flex-row gap-1 flex-wrap">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.post_code'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="successiveCarrierPostcode"
                                            [minlength]="2"
                                            [maxlength]="17" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation
                                                .get(
                                                    'successiveCarrierPostcode'
                                                )
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.city_name'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="successiveCarrierCity"
                                            [minlength]="2"
                                            [maxlength]="60" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation
                                                .get('successiveCarrierCity')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <ng-container
                                    formGroupName="successiveCarrierCountryCode">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.country'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="value"
                                            maxlength="2"
                                            (input)="
                                                transformToUppercase(
                                                    'successiveCarrier'
                                                )
                                            "
                                            (blur)="
                                                checkCountry(
                                                    'successiveCarrier'
                                                )
                                            "
                                            [matAutocomplete]="
                                                successiveCarrierAutocomplete
                                            " />
                                        <mat-autocomplete
                                            #successiveCarrierAutocomplete="matAutocomplete">
                                            @for (
                                                country of filteredSuccessiveCarrierCountries
                                                    | async;
                                                track country
                                            ) {
                                                <mat-option [value]="country"
                                                    >{{ country }}
                                                </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.successiveCarrierCountryCode
                                                .get('value')
                                                ?.hasError(
                                                    'mandatoryForSigning'
                                                )
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_mandatory'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.successiveCarrierCountryCode
                                                .get('value')
                                                ?.hasError('invalidCountryCode')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_countryCode'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </ng-container>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.successive_carrier_information.tax_number'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="text"
                                        formControlName="taxNumber"
                                        [maxlength]="255" />
                                    @if (
                                        ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.taxNumber?.hasError(
                                            'mandatoryForSigning'
                                        )
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_mandatory'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <!-- Vehicle configuration history (successive carrier) -->
                                <div
                                    formArrayName="vehicleConfigurationHistory"
                                    class="d-flex flex-column gap-2">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.vehicle_configuration.title'
                                                | translate
                                        }}
                                    </h6>
                                    @if (
                                        (ecmrConsignmentFormGroup.controls
                                            .successiveCarrierInformation
                                            .controls
                                            .vehicleConfigurationHistory.value
                                            | latestMotorPlate) !== ''
                                    ) {
                                        <p class="mb-1">
                                            {{
                                                'ECMR.ecmr_editor.vehicle_configuration.current_plate'
                                                    | translate
                                            }}:
                                            <strong>{{
                                                ecmrConsignmentFormGroup
                                                    .controls
                                                    .successiveCarrierInformation
                                                    .controls
                                                    .vehicleConfigurationHistory
                                                    .value | latestMotorPlate
                                            }}</strong>
                                        </p>
                                    }
                                    @for (
                                        configCtrl of ecmrConsignmentFormGroup
                                            .controls
                                            .successiveCarrierInformation
                                            .controls
                                            .vehicleConfigurationHistory
                                            .controls;
                                        let vIdx = $index;
                                        track configCtrl
                                    ) {
                                        <div
                                            class="d-flex flex-column gap-1 border rounded p-2"
                                            [formGroupName]="vIdx">
                                            <div
                                                class="d-flex align-items-center justify-content-between">
                                                <span class="fw-bold"
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.title'
                                                            | translate
                                                    }}
                                                    {{ vIdx + 1 }}</span
                                                >
                                                @if (
                                                    canFillSenderFields ||
                                                    canFillCarrierFields ||
                                                    canCarrierEditInTransport
                                                ) {
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        color="warn"
                                                        (click)="
                                                            removeVehicleConfig(
                                                                'successiveCarrier',
                                                                vIdx
                                                            )
                                                        "
                                                        [matTooltip]="
                                                            'ECMR.ecmr_editor.vehicle_configuration.remove'
                                                                | translate
                                                        ">
                                                        <mat-icon
                                                            fontSet="material-symbols-outlined"
                                                            >delete</mat-icon
                                                        >
                                                    </button>
                                                }
                                            </div>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.date'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    formControlName="timestamp"
                                                    [max]="today"
                                                    [matDatepicker]="
                                                        successiveVehicleConfigPicker
                                                    " />
                                                <mat-datepicker
                                                    #successiveVehicleConfigPicker></mat-datepicker>
                                                <mat-datepicker-toggle
                                                    matIconSuffix
                                                    [for]="
                                                        successiveVehicleConfigPicker
                                                    "></mat-datepicker-toggle>
                                                @if (
                                                    configCtrl
                                                        .get('timestamp')
                                                        ?.hasError('required')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.date_required'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                                @if (
                                                    configCtrl
                                                        .get('timestamp')
                                                        ?.hasError('futureDate')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.date_future'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.motor_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="motorVehicleLicensePlate"
                                                    [maxlength]="255" />
                                                @if (
                                                    configCtrl
                                                        .get(
                                                            'motorVehicleLicensePlate'
                                                        )
                                                        ?.hasError('required')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.vehicle_configuration.motor_plate_required'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.trailer_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="trailerLicensePlate"
                                                    [maxlength]="255" />
                                            </mat-form-field>
                                            <mat-form-field class="flex-grow-1">
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.vehicle_configuration.second_trailer_plate'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !(
                                                            canFillSenderFields ||
                                                            canFillCarrierFields ||
                                                            canCarrierEditInTransport
                                                        )
                                                    "
                                                    matInput
                                                    type="text"
                                                    formControlName="secondTrailerLicensePlate"
                                                    [maxlength]="255" />
                                            </mat-form-field>
                                        </div>
                                    }
                                    @if (
                                        canFillSenderFields ||
                                        canFillCarrierFields ||
                                        canCarrierEditInTransport
                                    ) {
                                        <button
                                            mat-stroked-button
                                            type="button"
                                            (click)="
                                                addVehicleConfig(
                                                    'successiveCarrier'
                                                )
                                            ">
                                            <mat-icon
                                                fontSet="material-symbols-outlined"
                                                >add</mat-icon
                                            >
                                            {{
                                                'ECMR.ecmr_editor.vehicle_configuration.add'
                                                    | translate
                                            }}
                                        </button>
                                    }
                                </div>
                                <div
                                    formGroupName="successiveCarrierContactInformation"
                                    class="d-flex flex-column">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.email'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="email"
                                            [maxlength]="255" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.successiveCarrierContactInformation
                                                .get('email')
                                                ?.hasError('invalidEmail')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_email'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.phone'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="carrierPhone"
                                            [maxlength]="32" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.successiveCarrierContactInformation
                                                .get('carrierPhone')
                                                ?.hasError('invalidPhoneNumber')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_phone'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.successive_carrier_information.driver_phone'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="driverPhone"
                                            [maxlength]="32" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.successiveCarrierInformation.controls.successiveCarrierContactInformation
                                                .get('driverPhone')
                                                ?.hasError('invalidPhoneNumber')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.common.errors.invalid_phone'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row">
                            <!-- Area 8 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="carriersReservationsAndObservationsOnTakingOverTheGoods">
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_8' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.carriers_reservations.reservation_and_observation'
                                                | translate
                                        }}
                                    </mat-label>
                                    <textarea
                                        [dynamicDisable]="!canFillCarrierFields"
                                        matInput
                                        cdkTextareaAutosize
                                        rows="5"
                                        formControlName="carrierReservationsObservations"
                                        [minlength]="2"
                                        [maxlength]="512"></textarea>
                                    @if (
                                        ecmrConsignmentFormGroup.controls.carriersReservationsAndObservationsOnTakingOverTheGoods
                                            .get(
                                                'carrierReservationsObservations'
                                            )
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <!-- Area 9 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="documentsHandedToCarrier">
                                <h6>
                                    {{ 'ECMR.ecmr_editor.title_9' | translate }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.documents_handed_to_carrier.remarks'
                                                | translate
                                        }}
                                    </mat-label>
                                    <textarea
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        cdkTextareaAutosize
                                        rows="5"
                                        formControlName="documentsRemarks"
                                        [minlength]="2"
                                        [maxlength]="512"></textarea>
                                    @if (
                                        ecmrConsignmentFormGroup.controls.documentsHandedToCarrier
                                            .get('documentsRemarks')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row">
                            <!-- Area 16 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="specialAgreementsSenderCarrier">
                                <h6>
                                    {{
                                        'ECMR.ecmr_editor.title_16' | translate
                                    }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.special_agreements_sen_carr.special_agreements'
                                                | translate
                                        }}
                                    </mat-label>
                                    <textarea
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        cdkTextareaAutosize
                                        rows="5"
                                        formControlName="customSpecialAgreement"
                                        [minlength]="2"
                                        [maxlength]="255"></textarea>
                                    @if (
                                        ecmrConsignmentFormGroup.controls.specialAgreementsSenderCarrier
                                            .get('customSpecialAgreement')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <!-- Area 17 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="toBePaidBy">
                                <h6>
                                    {{
                                        'ECMR.ecmr_editor.title_17' | translate
                                    }}
                                </h6>
                                <div
                                    class="d-flex flex-row gap-1 flex-wrap"
                                    formGroupName="customChargeCarriage">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.carriage_charges'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="number"
                                            formControlName="value"
                                            [min]="0"
                                            [max]="99999" />
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.currency'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="currency"
                                            [minlength]="2"
                                            [maxlength]="512" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.toBePaidBy.controls.customChargeCarriage
                                                .get('currency')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.payer'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <mat-select
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            formControlName="payer">
                                            <mat-option
                                                [value]="null"></mat-option>
                                            @for (
                                                payer of payerType;
                                                track payer
                                            ) {
                                                <mat-option
                                                    [value]="
                                                        payer.toUpperCase()
                                                    "
                                                    >{{
                                                        'ECMR.payer_type.' +
                                                            payer | translate
                                                    }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="d-flex flex-row gap-1 flex-wrap"
                                    formGroupName="customChargeSupplementary">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.supplementary_charges'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="number"
                                            formControlName="value"
                                            [min]="0"
                                            [max]="99999" />
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.currency'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="currency"
                                            [minlength]="2"
                                            [maxlength]="512" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.toBePaidBy.controls.customChargeSupplementary
                                                .get('currency')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.payer'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <mat-select
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            formControlName="payer">
                                            <mat-option
                                                [value]="null"></mat-option>
                                            @for (
                                                payer of payerType;
                                                track payer
                                            ) {
                                                <mat-option
                                                    [value]="
                                                        payer.toUpperCase()
                                                    "
                                                    >{{
                                                        'ECMR.payer_type.' +
                                                            payer | translate
                                                    }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="d-flex flex-row gap-1 flex-wrap"
                                    formGroupName="customChargeCustomsDuties">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.custom_duties_charges'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="number"
                                            formControlName="value"
                                            [min]="0"
                                            [max]="99999" />
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.currency'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="currency"
                                            [minlength]="2"
                                            [maxlength]="512" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.toBePaidBy.controls.customChargeCustomsDuties
                                                .get('currency')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.payer'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <mat-select
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            formControlName="payer">
                                            <mat-option
                                                [value]="null"></mat-option>
                                            @for (
                                                payer of payerType;
                                                track payer
                                            ) {
                                                <mat-option
                                                    [value]="
                                                        payer.toUpperCase()
                                                    "
                                                    >{{
                                                        'ECMR.payer_type.' +
                                                            payer | translate
                                                    }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="d-flex flex-row gap-1 flex-wrap"
                                    formGroupName="customChargeOther">
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.other_charges'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="number"
                                            formControlName="value"
                                            [min]="0"
                                            [max]="99999" />
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.currency'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <input
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            matInput
                                            type="text"
                                            formControlName="currency"
                                            [minlength]="2"
                                            [maxlength]="512" />
                                        @if (
                                            ecmrConsignmentFormGroup.controls.toBePaidBy.controls.customChargeOther
                                                .get('currency')
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.to_be_paid_by.payer'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <mat-select
                                            [dynamicDisable]="
                                                !canFillSenderFields
                                            "
                                            formControlName="payer">
                                            <mat-option
                                                [value]="null"></mat-option>
                                            @for (
                                                payer of payerType;
                                                track payer
                                            ) {
                                                <mat-option
                                                    [value]="
                                                        payer.toUpperCase()
                                                    "
                                                    >{{
                                                        'ECMR.payer_type.' +
                                                            payer | translate
                                                    }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card>
                    <mat-card-content class="container-fluid">
                        <div class="row">
                            <!-- Area 18 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col-lg-3"
                                formGroupName="otherUsefulParticulars">
                                <h6>
                                    {{
                                        'ECMR.ecmr_editor.title_18' | translate
                                    }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.other_useful_particulars.particulars'
                                                | translate
                                        }}
                                    </mat-label>
                                    <textarea
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        cdkTextareaAutosize
                                        rows="5"
                                        formControlName="customParticulars"
                                        [minlength]="2"
                                        [maxlength]="512"></textarea>
                                    @if (
                                        ecmrConsignmentFormGroup.controls.otherUsefulParticulars
                                            .get('customParticulars')
                                            ?.hasError('minlength')
                                    ) {
                                        <mat-error
                                            >{{
                                                'ECMR.ecmr_editor.error_too_short'
                                                    | translate
                                            }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <!-- Area 19 -->

                            <div
                                class="flex-grow-1 d-flex gap-1 flex-column col"
                                formGroupName="cashOnDelivery">
                                <h6>
                                    {{
                                        'ECMR.ecmr_editor.title_19' | translate
                                    }}
                                </h6>
                                <mat-form-field class="flex-grow-1">
                                    <mat-label
                                        >{{
                                            'ECMR.ecmr_editor.cash_on_delivery.particulars'
                                                | translate
                                        }}
                                    </mat-label>
                                    <input
                                        [dynamicDisable]="!canFillSenderFields"
                                        matInput
                                        type="number"
                                        formControlName="customCashOnDelivery"
                                        [min]="1"
                                        [max]="999999" />
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                @if (
                    getTransportType(ecmrToEdit) ===
                    EcmrTransportType.International
                ) {
                    <mat-card>
                        <mat-card-content class="container-fluid">
                            <div class="row">
                                <!-- Area 20 -->
                                <div
                                    class="flex-grow-1 d-flex gap-1 flex-column col">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_20'
                                                | translate
                                        }}
                                    </h6>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                @if (!isTemplate()) {
                    <mat-card id="ecmr-signature-scroll">
                        <mat-card-content class="container-fluid">
                            <div class="row">
                                <!-- Area 21 -->

                                <div
                                    class="flex-grow-1 d-flex gap-1 flex-column col"
                                    formGroupName="established">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_21'
                                                | translate
                                        }}
                                    </h6>
                                    <div
                                        class="d-flex flex-row flex-wrap gap-2 mb-3">
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.established.in'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="customEstablishedIn"
                                                [minlength]="2"
                                                [maxlength]="30" />
                                            @if (
                                                ecmrConsignmentFormGroup.controls.established
                                                    .get('customEstablishedIn')
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                ecmrConsignmentFormGroup.controls.established
                                                    .get('customEstablishedIn')
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.established.on'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                formControlName="customEstablishedDate"
                                                [matDatepicker]="
                                                    establishedDatePicker
                                                " />
                                            <mat-datepicker
                                                #establishedDatePicker></mat-datepicker>
                                            <mat-datepicker-toggle
                                                matIconSuffix
                                                [for]="
                                                    establishedDatePicker
                                                "></mat-datepicker-toggle>
                                            @if (
                                                ecmrConsignmentFormGroup.controls.established.get(
                                                    'customEstablishedDate'
                                                )?.invalid
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <!-- Area 22 -->

                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_22'
                                                | translate
                                        }}
                                    </h6>
                                    @if (senderSealMetadata) {
                                        <div
                                            class="signed-content d-flex justify-content-center align-items-center flex-column rounded p-3 col-12 col-md-8">
                                            <p>
                                                {{
                                                    'ECMR.ecmr_editor.eseal_information'
                                                        | translate
                                                }}
                                            </p>
                                            <span
                                                class="signature-date d-flex justify-content-center mt-2"
                                                >{{
                                                    'ECMR.signature.signed_on'
                                                        | translate
                                                }}
                                                {{
                                                    dateTimeService.transformDate(
                                                        senderSealMetadata.timestamp
                                                    )
                                                }}</span
                                            >
                                            <p class="text-center mt-2">
                                                {{
                                                    'ECMR.signature.by'
                                                        | translate
                                                }}
                                                {{ senderSealMetadata.sealer }}
                                            </p>
                                        </div>
                                    } @else {
                                        <button
                                            [disabled]="
                                                !canFillSenderFields ||
                                                isReadOnly
                                            "
                                            mat-flat-button
                                            class="mb-3"
                                            color="primary"
                                            (click)="sealSender()">
                                            {{
                                                'ECMR.ecmr_editor.seal'
                                                    | translate
                                            }}
                                        </button>
                                    }

                                    <!-- Area 23 -->

                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_23'
                                                | translate
                                        }}
                                    </h6>
                                    @if (carrierSealMetadata) {
                                        <div
                                            class="signed-content d-flex justify-content-center align-items-center flex-column rounded p-3 col-12 col-md-8">
                                            <p>
                                                {{
                                                    'ECMR.ecmr_editor.eseal_information'
                                                        | translate
                                                }}
                                            </p>
                                            <span
                                                class="signature-date d-flex justify-content-center mt-2"
                                                >{{
                                                    'ECMR.signature.signed_on'
                                                        | translate
                                                }}
                                                {{
                                                    dateTimeService.transformDate(
                                                        carrierSealMetadata.timestamp
                                                    )
                                                }}</span
                                            >
                                            <p class="text-center mt-2">
                                                {{
                                                    'ECMR.signature.by'
                                                        | translate
                                                }}
                                                {{ carrierSealMetadata.sealer }}
                                            </p>
                                        </div>
                                    } @else {
                                        <button
                                            [disabled]="
                                                !canFillCarrierFields ||
                                                this.editorMode !==
                                                    EditorMode.ECMR_EDIT ||
                                                isReadOnly
                                            "
                                            mat-flat-button
                                            class="mb-3"
                                            color="primary"
                                            (click)="sealCarrier()">
                                            {{
                                                'ECMR.ecmr_editor.seal'
                                                    | translate
                                            }}
                                        </button>
                                    }
                                </div>

                                <!-- Area 24 -->

                                <div
                                    class="flex-grow-1 d-flex gap-1 flex-column col"
                                    formGroupName="goodsReceived">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_24'
                                                | translate
                                        }}
                                    </h6>
                                    <div
                                        class="d-flex flex-row flex-wrap gap-2">
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.receival_signature.place'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !(
                                                        canFillConsigneeFields ||
                                                        canCarrierEditInTransport
                                                    )
                                                "
                                                matInput
                                                type="text"
                                                formControlName="confirmedLogisticsLocationName"
                                                [minlength]="2"
                                                [maxlength]="60" />
                                            @if (
                                                ecmrConsignmentFormGroup.controls.goodsReceived
                                                    .get(
                                                        'confirmedLogisticsLocationName'
                                                    )
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                ecmrConsignmentFormGroup.controls.goodsReceived
                                                    .get(
                                                        'confirmedLogisticsLocationName'
                                                    )
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.receival_signature.date'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !(
                                                        canFillConsigneeFields ||
                                                        canCarrierEditInTransport
                                                    )
                                                "
                                                matInput
                                                formControlName="consigneeSignatureDate"
                                                [matDatepicker]="
                                                    consigneeSignatureDatePicker
                                                " />
                                            <mat-datepicker
                                                #consigneeSignatureDatePicker></mat-datepicker>
                                            <mat-datepicker-toggle
                                                matIconSuffix
                                                [for]="
                                                    consigneeSignatureDatePicker
                                                "></mat-datepicker-toggle>
                                            @if (
                                                ecmrConsignmentFormGroup.controls.goodsReceived.get(
                                                    'consigneeSignatureDate'
                                                )?.invalid
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field class="flex-grow-1">
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.receival_signature.remarks'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <textarea
                                                [dynamicDisable]="
                                                    !(
                                                        canFillConsigneeFields ||
                                                        canCarrierEditInTransport
                                                    )
                                                "
                                                matInput
                                                cdkTextareaAutosize
                                                rows="5"
                                                formControlName="consigneeReservationsObservations"
                                                [minlength]="2"
                                                [maxlength]="512"></textarea>
                                            @if (
                                                ecmrConsignmentFormGroup.controls.goodsReceived
                                                    .get(
                                                        'consigneeReservationsObservations'
                                                    )
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.title_24_signature'
                                                | translate
                                        }}
                                    </h6>
                                    @if (consigneeSignature) {
                                        <div
                                            class="signed-content d-flex justify-content-center align-items-center flex-column rounded p-3 col-12 col-md-8">
                                            <img
                                                [src]="consigneeSignature.data"
                                                alt="signature"
                                                class="img-fluid rounded mb-2" />
                                            <span
                                                class="signature-date d-flex justify-content-center mt-2"
                                                >{{
                                                    'ECMR.signature.signed_on'
                                                        | translate
                                                }}
                                                {{
                                                    dateTimeService.transformDate(
                                                        consigneeSignature.timestamp
                                                    )
                                                }}</span
                                            >
                                            <p class="text-center mt-2">
                                                {{
                                                    'ECMR.signature.by'
                                                        | translate
                                                }}
                                                {{
                                                    consigneeSignature.userName
                                                }}
                                            </p>
                                            @if (consigneeSealMetadata) {
                                                <p class="mt-2">
                                                    {{
                                                        'ECMR.ecmr_editor.eseal_information'
                                                            | translate
                                                    }}
                                                </p>
                                                <span
                                                    class="signature-date d-flex justify-content-center mt-2"
                                                    >{{
                                                        'ECMR.signature.signed_on'
                                                            | translate
                                                    }}
                                                    {{
                                                        dateTimeService.transformDate(
                                                            consigneeSealMetadata.timestamp
                                                        )
                                                    }}</span
                                                >
                                                <p class="text-center mt-2">
                                                    {{
                                                        'ECMR.signature.by'
                                                            | translate
                                                    }}
                                                    {{
                                                        consigneeSealMetadata.sealer
                                                    }}
                                                </p>
                                            }
                                        </div>
                                    } @else {
                                        <button
                                            [disabled]="
                                                !canFillConsigneeFields ||
                                                this.editorMode !==
                                                    EditorMode.ECMR_EDIT ||
                                                isReadOnly
                                            "
                                            mat-flat-button
                                            color="primary"
                                            (click)="signConsignee()">
                                            {{
                                                'ECMR.ecmr_editor.sign_on_glass'
                                                    | translate
                                            }}
                                        </button>
                                    }
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card>
                        <mat-card-content class="container-fluid">
                            <div class="row">
                                <!-- Area 25 -->

                                <div
                                    class="flex-grow-1 d-flex gap-1 flex-column"
                                    formGroupName="nonContractualPartReservedForTheCarrier">
                                    <h6>
                                        {{
                                            'ECMR.ecmr_editor.non_contractual_part_reserved_for_the_carrier'
                                                | translate
                                        }}
                                    </h6>
                                    <mat-form-field class="flex-grow-1">
                                        <mat-label
                                            >{{
                                                'ECMR.ecmr_editor.remarks'
                                                    | translate
                                            }}
                                        </mat-label>
                                        <textarea
                                            [dynamicDisable]="
                                                !canFillCarrierFields
                                            "
                                            matInput
                                            cdkTextareaAutosize
                                            rows="5"
                                            formControlName="nonContractualCarrierRemarks"
                                            [minlength]="2"
                                            [maxlength]="512"></textarea>
                                        @if (
                                            ecmrConsignmentFormGroup.controls.nonContractualPartReservedForTheCarrier.controls.nonContractualCarrierRemarks
                                                .get(
                                                    'confirmedLogisticsLocationName'
                                                )
                                                ?.hasError('minlength')
                                        ) {
                                            <mat-error
                                                >{{
                                                    'ECMR.ecmr_editor.error_too_short'
                                                        | translate
                                                }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                @if (ecmrToEdit?.ecmrId && !isTemplate()) {
                    <app-ecmr-documents
                        [ecmrId]="ecmrToEdit.ecmrId!"
                        [userToken]="userToken"
                        [tan]="tan"
                        [disabled]="isReadOnly">
                    </app-ecmr-documents>
                }
            </div>
            @if (!isTemplate()) {
                <div class="col-lg-6 m-3 gap-3 overflow-container">
                    <ng-container
                        *ngTemplateOutlet="itemListTemplate"></ng-container>
                </div>
            }
        </div>
        <ng-template #itemListTemplate>
            <mat-accordion
                multi
                class="flex-grow-1"
                formArrayName="itemList">
                @for (item of itemList.controls; let i = $index; track item) {
                    <mat-expansion-panel
                        togglePosition="before"
                        [formGroupName]="i"
                        [expanded]="$first">
                        <mat-expansion-panel-header>
                            <mat-panel-title
                                class="d-flex flex-row justify-content-between align-items-center">
                                @if (
                                    item.controls.numberOfPackages.controls
                                        .logisticsPackageItemQuantity.value &&
                                    item.controls.marksAndNos.controls
                                        .logisticsShippingMarksMarking.value
                                ) {
                                    <div
                                        [ngClass]="{
                                            'invalid-highlight': item.invalid,
                                        }">
                                        {{
                                            'ECMR.ecmr_editor.item' | translate
                                        }}
                                        {{
                                            i +
                                                1 +
                                                ' - ' +
                                                item.controls.numberOfPackages
                                                    .controls
                                                    .logisticsPackageItemQuantity
                                                    .value +
                                                ' x ' +
                                                item.controls.marksAndNos
                                                    .controls
                                                    .logisticsShippingMarksMarking
                                                    .value
                                        }}
                                    </div>
                                } @else {
                                    <div
                                        [ngClass]="{
                                            'invalid-highlight': item.invalid,
                                        }">
                                        {{
                                            'ECMR.ecmr_editor.item' | translate
                                        }}
                                        {{ i + 1 }}
                                    </div>
                                }
                                @if (canFillSenderFields) {
                                    <button
                                        mat-icon-button
                                        (click)="deleteItem(i)">
                                        <mat-icon
                                            fontSet="material-symbols-outlined"
                                            color="warn"
                                            >delete
                                        </mat-icon>
                                    </button>
                                }
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col align-items-start">
                                    <!-- Area 10 -->

                                    <div
                                        formGroupName="marksAndNos"
                                        class="flex-grow-1 d-flex gap-1 flex-column">
                                        <h6>
                                            {{
                                                'ECMR.ecmr_editor.title_10'
                                                    | translate
                                            }}
                                        </h6>
                                        <mat-form-field>
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.marks_and_nos.marking_text'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="logisticsShippingMarksMarking"
                                                [minlength]="2"
                                                [maxlength]="512" />
                                            @if (
                                                item.controls.marksAndNos
                                                    .get(
                                                        'logisticsShippingMarksMarking'
                                                    )
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                item.controls.marksAndNos
                                                    .get(
                                                        'logisticsShippingMarksMarking'
                                                    )
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                        <div
                                            formArrayName="logisticsShippingMarksCustomBarcodeList">
                                            @for (
                                                barcodeCtrl of item.controls
                                                    .marksAndNos.controls
                                                    .logisticsShippingMarksCustomBarcodeList
                                                    .controls;
                                                let bIdx = $index;
                                                track barcodeCtrl
                                            ) {
                                                <div
                                                    class="d-flex align-items-center gap-1">
                                                    <mat-form-field
                                                        class="flex-grow-1">
                                                        <mat-label
                                                            >{{
                                                                'ECMR.ecmr_editor.marks_and_nos.barcode_number'
                                                                    | translate
                                                            }}
                                                            {{ bIdx + 1 }}
                                                        </mat-label>
                                                        <input
                                                            [dynamicDisable]="
                                                                !canFillSenderFields
                                                            "
                                                            matInput
                                                            type="text"
                                                            [formControlName]="
                                                                bIdx
                                                            "
                                                            [minlength]="2"
                                                            [maxlength]="35" />
                                                        @if (
                                                            barcodeCtrl.hasError(
                                                                'mandatoryForSigning'
                                                            )
                                                        ) {
                                                            <mat-error
                                                                >{{
                                                                    'ECMR.ecmr_editor.error_mandatory'
                                                                        | translate
                                                                }}
                                                            </mat-error>
                                                        }
                                                        @if (
                                                            barcodeCtrl.hasError(
                                                                'minlength'
                                                            )
                                                        ) {
                                                            <mat-error
                                                                >{{
                                                                    'ECMR.ecmr_editor.error_too_short'
                                                                        | translate
                                                                }}
                                                            </mat-error>
                                                        }
                                                    </mat-form-field>
                                                    @if (
                                                        canFillSenderFields &&
                                                        item.controls
                                                            .marksAndNos
                                                            .controls
                                                            .logisticsShippingMarksCustomBarcodeList
                                                            .length > 1
                                                    ) {
                                                        <button
                                                            mat-icon-button
                                                            type="button"
                                                            (click)="
                                                                removeBarcodeFromItem(
                                                                    i,
                                                                    bIdx
                                                                )
                                                            "
                                                            [matTooltip]="
                                                                'ECMR.ecmr_editor.marks_and_nos.remove_barcode'
                                                                    | translate
                                                            ">
                                                            <mat-icon
                                                                fontSet="material-symbols-outlined"
                                                                >close
                                                            </mat-icon>
                                                        </button>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        @if (canFillSenderFields) {
                                            <button
                                                mat-stroked-button
                                                type="button"
                                                (click)="addBarcodeToItem(i)">
                                                <mat-icon
                                                    fontSet="material-symbols-outlined"
                                                    >add</mat-icon
                                                >
                                                {{
                                                    'ECMR.ecmr_editor.marks_and_nos.add_barcode'
                                                        | translate
                                                }}
                                            </button>
                                        }
                                    </div>

                                    <!-- Area 11 -->

                                    <div
                                        formGroupName="numberOfPackages"
                                        class="flex-grow-1 d-flex gap-1 flex-column">
                                        <h6>
                                            {{
                                                'ECMR.ecmr_editor.title_11'
                                                    | translate
                                            }}
                                        </h6>
                                        <mat-form-field>
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.number_of_packages.item_quantity'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="number"
                                                formControlName="logisticsPackageItemQuantity"
                                                [min]="0"
                                                [max]="9999" />
                                            @if (
                                                item.controls.numberOfPackages
                                                    .get(
                                                        'logisticsPackageItemQuantity'
                                                    )
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col align-items-start">
                                    <!-- Area 12 -->

                                    <div
                                        formGroupName="methodOfPacking"
                                        class="flex-grow-1 d-flex gap-1 flex-column">
                                        <h6>
                                            {{
                                                'ECMR.ecmr_editor.title_12'
                                                    | translate
                                            }}
                                        </h6>
                                        <mat-form-field>
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.method_of_packing.type_text'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="logisticsPackageType"
                                                [minlength]="2"
                                                [maxlength]="35" />
                                            @if (
                                                item.controls.methodOfPacking
                                                    .get('logisticsPackageType')
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                item.controls.methodOfPacking
                                                    .get('logisticsPackageType')
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <!-- Area 13 -->

                                    <div
                                        formGroupName="natureOfTheGoods"
                                        class="flex-grow-1 d-flex gap-1 flex-column">
                                        <h6>
                                            {{
                                                'ECMR.ecmr_editor.title_13'
                                                    | translate
                                            }}
                                        </h6>
                                        <mat-form-field>
                                            <mat-label
                                                >{{
                                                    'ECMR.ecmr_editor.nature_of_goods.identification_text'
                                                        | translate
                                                }}
                                            </mat-label>
                                            <input
                                                [dynamicDisable]="
                                                    !canFillSenderFields
                                                "
                                                matInput
                                                type="text"
                                                formControlName="transportCargoIdentification"
                                                [minlength]="2"
                                                [maxlength]="512" />
                                            @if (
                                                item.controls.natureOfTheGoods
                                                    .get(
                                                        'transportCargoIdentification'
                                                    )
                                                    ?.hasError(
                                                        'mandatoryForSigning'
                                                    )
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_mandatory'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                            @if (
                                                item.controls.natureOfTheGoods
                                                    .get(
                                                        'transportCargoIdentification'
                                                    )
                                                    ?.hasError('minlength')
                                            ) {
                                                <mat-error
                                                    >{{
                                                        'ECMR.ecmr_editor.error_too_short'
                                                            | translate
                                                    }}
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <!-- Area 14 -->

                                    <div
                                        class="d-flex flex-row gap-2 flex-wrap">
                                        <div
                                            formGroupName="grossWeightInKg"
                                            class="flex-grow-1 d-flex gap-1 flex-column">
                                            <h6>
                                                {{
                                                    'ECMR.ecmr_editor.title_14'
                                                        | translate
                                                }}
                                            </h6>
                                            <mat-form-field>
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.gross_weight_in_kg.gross_weight'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="number"
                                                    formControlName="supplyChainConsignmentItemGrossWeight"
                                                    step="any"
                                                    [min]="1"
                                                    [max]="99999" />
                                                @if (
                                                    item.controls.grossWeightInKg.get(
                                                        'supplyChainConsignmentItemGrossWeight'
                                                    )?.invalid
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>

                                        <!-- Area 15 -->

                                        <div
                                            formGroupName="volumeInM3"
                                            class="flex-grow-1 d-flex gap-1 flex-column">
                                            <h6>
                                                {{
                                                    'ECMR.ecmr_editor.title_15'
                                                        | translate
                                                }}
                                            </h6>
                                            <mat-form-field>
                                                <mat-label
                                                    >{{
                                                        'ECMR.ecmr_editor.volume_in_m3.volume'
                                                            | translate
                                                    }}
                                                </mat-label>
                                                <input
                                                    [dynamicDisable]="
                                                        !canFillSenderFields
                                                    "
                                                    matInput
                                                    type="number"
                                                    formControlName="supplyChainConsignmentItemGrossVolume"
                                                    [max]="9999" />
                                                @if (
                                                    item.controls.volumeInM3
                                                        .get(
                                                            'supplyChainConsignmentItemGrossVolume'
                                                        )
                                                        ?.hasError(
                                                            'mandatoryForSigning'
                                                        )
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_mandatory'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }

                                                @if (
                                                    item.controls.volumeInM3
                                                        .get(
                                                            'supplyChainConsignmentItemGrossVolume'
                                                        )
                                                        ?.hasError('minValue')
                                                ) {
                                                    <mat-error
                                                        >{{
                                                            'ECMR.ecmr_editor.error_volume_min'
                                                                | translate
                                                        }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }
            </mat-accordion>
            @if (!isTemplate()) {
                <div class="d-flex flex-row justify-content-between">
                    <button
                        [disabled]="!canFillSenderFields"
                        mat-stroked-button
                        color="primary"
                        class="mt-2"
                        (click)="addNewItem()">
                        <mat-icon
                            fontSet="material-symbols-outlined"
                            iconPositionEnd
                            >add
                        </mat-icon>
                        {{ 'ECMR.ecmr_editor.add_item' | translate }}
                    </button>
                    <div class="d-flex gap-2 flex-row">
                        <button
                            mat-icon-button
                            color="accent"
                            class="custom-stroked-icon-button"
                            (click)="accordion()?.openAll()">
                            <mat-icon fontSet="material-symbols-outlined"
                                >expand
                            </mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            color="accent"
                            class="custom-stroked-icon-button"
                            (click)="accordion()?.closeAll()">
                            <mat-icon fontSet="material-symbols-outlined"
                                >compress
                            </mat-icon>
                        </button>
                    </div>
                </div>
            }
            <!-- Special Permits (consignment-level list) -->
            @if (!isTemplate()) {
                <div
                    formArrayName="specialPermits"
                    class="d-flex flex-column gap-2 mt-4">
                    <h6>
                        {{
                            'ECMR.ecmr_editor.special_permits.title' | translate
                        }}
                    </h6>
                    @for (
                        permitCtrl of ecmrConsignmentFormGroup.controls
                            .specialPermits.controls;
                        let pIdx = $index;
                        track permitCtrl
                    ) {
                        <div
                            class="d-flex flex-column gap-1 border rounded p-2"
                            [formGroupName]="pIdx">
                            <div
                                class="d-flex align-items-center justify-content-between">
                                <span class="fw-bold"
                                    >{{
                                        'ECMR.ecmr_editor.special_permits.title'
                                            | translate
                                    }}
                                    {{ pIdx + 1 }}</span
                                >
                                @if (canFillSenderFields) {
                                    <button
                                        mat-icon-button
                                        type="button"
                                        color="warn"
                                        (click)="removeSpecialPermit(pIdx)"
                                        [matTooltip]="
                                            'ECMR.ecmr_editor.special_permits.remove'
                                                | translate
                                        ">
                                        <mat-icon
                                            fontSet="material-symbols-outlined"
                                            >delete</mat-icon
                                        >
                                    </button>
                                }
                            </div>
                            <mat-form-field class="flex-grow-1">
                                <mat-label
                                    >{{
                                        'ECMR.ecmr_editor.special_permits.type'
                                            | translate
                                    }}
                                </mat-label>
                                <input
                                    [dynamicDisable]="!canFillSenderFields"
                                    matInput
                                    type="text"
                                    formControlName="type"
                                    [maxlength]="64" />
                            </mat-form-field>
                            <mat-form-field class="flex-grow-1">
                                <mat-label
                                    >{{
                                        'ECMR.ecmr_editor.special_permits.reference'
                                            | translate
                                    }}
                                </mat-label>
                                <input
                                    [dynamicDisable]="!canFillSenderFields"
                                    matInput
                                    type="text"
                                    formControlName="reference"
                                    [maxlength]="64" />
                            </mat-form-field>
                            <mat-form-field class="flex-grow-1">
                                <mat-label
                                    >{{
                                        'ECMR.ecmr_editor.special_permits.description'
                                            | translate
                                    }}
                                </mat-label>
                                <textarea
                                    [dynamicDisable]="!canFillSenderFields"
                                    matInput
                                    cdkTextareaAutosize
                                    rows="2"
                                    formControlName="description"
                                    [maxlength]="512"></textarea>
                            </mat-form-field>
                        </div>
                    }
                    @if (canFillSenderFields) {
                        <button
                            mat-stroked-button
                            type="button"
                            color="primary"
                            class="align-self-start"
                            (click)="addSpecialPermit()">
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                iconPositionEnd
                                >add</mat-icon
                            >
                            {{
                                'ECMR.ecmr_editor.special_permits.add'
                                    | translate
                            }}
                        </button>
                    }
                </div>
            }
        </ng-template>
    </div>
</div>
